{
	"roles": {
		"SUPER_ADMIN": "Super Admin",
		"ADMIN": "Admin",
		"MEDAL_DESK": "Medal desk",
		"OPERATION": "Operation",
		"ORGANIZATION": "Organization",
		"TRANSPORT_PROVIDER": "Transport provider",
		"HOTEL": "Hotel",
		"WORKFORCE": "Workforce",
		"PARTICIPANT": "Participant",
		"PUBLIC": "Public"
	},
	"status": {
		"ACTIVE": "Active",
		"INACTIVE": "Inactive",
		"SUSPENDED": "Suspended"
	},
	"statusHint": {
		"ACTIVE": "Can sign in.",
		"INACTIVE": "Left the organisation. Sign-in blocked, every session ends.",
		"SUSPENDED": "Temporarily blocked. Sign-in blocked, every session ends."
	},
	"never": "never",
	"index": {
		"title": "Users",
		"count_one": "{{n}} user",
		"count_other": "{{n}} users",
		"subtitle": "Accounts, roles and lock status. Unlock clears every limiter counter.",
		"newUser": "New user"
	},
	"filters": {
		"search": "Name, Username or Email",
		"button": "Filters",
		"sheetTitle": "Filter users",
		"role": "Role",
		"status": "Status",
		"allRoles": "All roles",
		"allStatuses": "All statuses",
		"group": "Group",
		"allGroups": "All groups",
		"clear": "Clear filters"
	},
	"bulk": {
		"unlock": "Unlock",
		"unlockTitle": "Clear every rate-limit counter so they can sign in right now",
		"activate": "Activate",
		"suspend": "Suspend",
		"suspendTitle": "Blocks sign-in and signs them out on every device",
		"updated_one": "{{label}}: {{count}} user updated.",
		"updated_other": "{{label}}: {{count}} users updated.",
		"failedSummary": "{{label}}: {{failed}} of {{total}} failed",
		"signOut": "Sign out",
		"signOutTitle": "End every session they have, on every device",
		"activated_one": "{{count}} user activated.",
		"activated_other": "{{count}} users activated.",
		"suspended_one": "{{count}} user suspended and signed out everywhere.",
		"suspended_other": "{{count}} users suspended and signed out everywhere.",
		"signedOut_one": "{{count}} user signed out everywhere.",
		"signedOut_other": "{{count}} users signed out everywhere.",
		"nothingChanged": "Nothing changed — the selected users already had that status.",
		"confirm": {
			"activateTitle_one": "Activate {{count}} user",
			"activateTitle_other": "Activate {{count}} users",
			"activateBody_one": "{{count}} user will be able to sign in again.",
			"activateBody_other": "{{count}} users will be able to sign in again.",
			"activateFailed": "Couldn't activate users",
			"suspendTitle_one": "Suspend {{count}} user",
			"suspendTitle_other": "Suspend {{count}} users",
			"suspendBody_one": "{{count}} user will be blocked from signing in and signed out on every device right away.",
			"suspendBody_other": "{{count}} users will be blocked from signing in and signed out on every device right away.",
			"suspendFailed": "Couldn't suspend users",
			"signOutTitle_one": "Sign out {{count}} user",
			"signOutTitle_other": "Sign out {{count}} users",
			"signOutBody_one": "{{count}} user will be signed out on every device right away. They can sign in again with their password.",
			"signOutBody_other": "{{count}} users will be signed out on every device right away. They can sign in again with their password.",
			"signOutFailed": "Couldn't sign users out"
		}
	},
	"table": {
		"headers": {
			"user": "User",
			"contact": "Contact",
			"roles": "Roles",
			"group": "Group",
			"status": "Status",
			"mfa": "2FA",
			"lastSignIn": "Last sign-in",
			"created": "Created"
		},
		"mustChangePassword": "— must change password",
		"mfaOn": "On",
		"groupInactiveTitle": "This group is inactive — it grants nothing",
		"viewAria": "View {{name}}",
		"editAria": "Edit {{name}}",
		"resetPasswordAria": "Reset password for {{name}}",
		"summary_one": "{{from}}–{{to}} of {{total}} user",
		"summary_other": "{{from}}–{{to}} of {{total}} users",
		"empty": {
			"noMatchTitle": "No users match these filters",
			"noMatchDescription": "Try a broader search, or clear the filters.",
			"noneTitle": "No users yet",
			"noneDescription": "Create the first account to get started."
		}
	},
	"detail": {
		"subtitle": "User account",
		"errorTransientTitle": "Server unreachable",
		"errorTitle": "Couldn't load this user",
		"tryAgain": "Try again",
		"backToUsers": "Back to users",
		"badge2faOn": "2FA on",
		"badgePasswordPending": "Password change pending",
		"badgeYou": "You",
		"unlock": "Unlock",
		"unlocked": "Unlocked — they can sign in right now.",
		"unlockFailed": "Couldn't unlock",
		"resetPassword": "Reset password",
		"edit": "Edit",
		"profile": {
			"title": "Profile",
			"email": "Email",
			"phone": "Phone",
			"roles": "Roles",
			"lastSignIn": "Last sign-in",
			"created": "Created",
			"updated": "Updated",
			"id": "ID"
		},
		"tabs": {
			"ariaLabel": "Account history",
			"activity": "Activity by {{name}}",
			"history": "Changes to this account",
			"signIns": "Sign-ins"
		}
	},
	"sessions": {
		"title": "Sessions",
		"signOutAll": "Sign out all",
		"signedOutEverywhere_one": "{{name}} is signed out everywhere — {{count}} session ended.",
		"signedOutEverywhere_other": "{{name}} is signed out everywhere — {{count}} sessions ended.",
		"signOutFailed": "Couldn't sign them out",
		"empty": "Not signed in anywhere.",
		"showMore": "Show more ({{count}} hidden)",
		"unknownDevice": "Unknown device",
		"activeNow": "Active now",
		"idle": "Idle",
		"seen": "seen {{stamp}}",
		"confirm": {
			"title": "Sign out everywhere",
			"body": "<strong>{{name}}</strong> will be signed out on every device right away. They can sign in again with their password.",
			"submit": "Sign out everywhere"
		}
	},
	"activity": {
		"emptyFilteredTitle": "Nothing matches these filters",
		"emptyActorTitle": "{{name}} hasn't changed anything yet",
		"emptySubjectTitle": "No changes recorded for this account",
		"emptyFilteredHint": "Try a wider date range, another module, or clear the filters.",
		"emptyActorHint": "Creating accounts, editing profiles, changing roles or resetting passwords will show up here, newest first.",
		"emptySubjectHint": "Every edit to this account — by whom, when, and what changed — is recorded here.",
		"showOlder": "Show older",
		"byLine": "by <link>{{name}}</link>",
		"unknownUser": "Unknown user",
		"changed": "changed",
		"yes": "yes",
		"no": "no",
		"grantedRole": "Granted {{role}}",
		"removedRole": "Removed {{role}}",
		"roleFallback": "role",
		"grantedScope": "Granted scope",
		"removedScope": "Removed scope",
		"createdEntity": "Created {{table}}",
		"updatedEntity": "Updated {{table}}",
		"deletedEntity": "Deleted {{table}}",
		"fields": {
			"password_hash": "Password",
			"must_change_password": "Must change password",
			"role_code": "Role",
			"confirmed_at": "2FA confirmed",
			"responsible_organization_id": "Organization",
			"main_function_id": "Main function",
			"sub_agency_id": "Sub-agency",
			"sub_function_id": "Sub-function",
			"user_group_id": "User group",
			"secret_enc": "2FA secret",
			"backup_code_hashes": "Backup codes",
			"last_login_at": "Last sign-in",
			"created_at": "Created",
			"updated_at": "Updated"
		},
		"filters": {
			"search": "Reason, Name or Username",
			"module": "Module",
			"action": "Action",
			"from": "From",
			"to": "To",
			"allModules": "All modules",
			"anyAction": "Any action",
			"created": "Created",
			"updated": "Updated",
			"deleted": "Deleted"
		},
		"modules": {
			"users": "Users & access",
			"people": "People",
			"accreditation": "Accreditation",
			"competition": "Competition",
			"functions": "Functions",
			"reference": "Reference data"
		},
		"actorTypes": {
			"USER": "User",
			"AI_AGENT": "AI agent",
			"SYSTEM": "System",
			"MIGRATION": "Migration",
			"CUSTOMER": "Store customer"
		}
	},
	"signIns": {
		"loading": "Loading sign-ins…",
		"locked_one": "<strong>Locked</strong> after {{count}} failed attempt.",
		"locked_other": "<strong>Locked</strong> after {{count}} failed attempts.",
		"lockedClears_one": "<strong>Locked</strong> after {{count}} failed attempt — clears in {{minutes}} min.",
		"lockedClears_other": "<strong>Locked</strong> after {{count}} failed attempts — clears in {{minutes}} min.",
		"unlockNow": "Unlock now",
		"recentFailures_one": "{{count}} recent failed attempt — not locked.",
		"recentFailures_other": "{{count}} recent failed attempts — not locked.",
		"empty": "No sign-in attempts yet.",
		"unknownApp": "Unknown app",
		"filterApp": "App",
		"filterOutcome": "Outcome",
		"allApps": "All apps",
		"allOutcomes": "All",
		"refused": "Refused",
		"logEmpty": "No sign-in attempts match.",
		"loadMore": "Load more",
		"summary_one": "{{from}}–{{to}} of {{total}} attempt",
		"summary_other": "{{from}}–{{to}} of {{total}} attempts",
		"ua": {
			"apiClient": "API client",
			"browser": "Browser"
		},
		"reasons": {
			"OK": "Signed in",
			"INVALID_CREDENTIALS": "Wrong password",
			"ACCOUNT_INACTIVE": "Account not active",
			"NO_ROLES_ASSIGNED": "No roles",
			"ROLE_NOT_HELD": "Role not held",
			"RATE_LIMITED": "Rate limited",
			"MFA_REQUIRED": "2FA code needed",
			"MFA_ENROLLMENT_REQUIRED": "2FA set-up needed",
			"MFA_INVALID_CODE": "Wrong 2FA code",
			"MFA_RATE_LIMITED": "2FA rate limited"
		}
	},
	"form": {
		"create": {
			"title": "New user",
			"submit": "Create user",
			"created": "{{name}} created.",
			"error": "Couldn't create user"
		},
		"edit": {
			"title": "Edit {{name}}",
			"createdOn": "created {{date}}",
			"submit": "Save changes",
			"nothingToSave": "Nothing to save.",
			"updated": "{{name}} updated.",
			"partialError": "Saved partially — remaining change failed",
			"error": "Couldn't save"
		},
		"sections": {
			"profile": "Profile",
			"profileHintCreate": "The username is what they type to sign in — no '@' or spaces.",
			"profileHintEdit": "Changing the username changes what they type to sign in.",
			"access": "Access",
			"accessHintCreate": "They pick one of these roles at each sign-in. New accounts start Active.",
			"accessHintSelf": "You can't change your own roles or status.",
			"accessHintEdit": "Removing a role, or any status but Active, signs them out everywhere.",
			"password": "Password",
			"passwordHintTyped": "At least 8 characters.",
			"passwordHintBlank": "Leave it blank and a phone-friendly one (Mango-Tiger-4821) is generated and shown to you once.",
			"passwordHintEdit": "Signs them out everywhere. You'll confirm with your own password."
		},
		"fullName": {
			"label": "Full name"
		},
		"username": {
			"label": "Username"
		},
		"phone": {
			"label": "Phone"
		},
		"email": {
			"label": "Email"
		},
		"roles": {
			"label": "Roles",
			"loading": "Loading roles…",
			"placeholder": "Pick roles",
			"requires2fa": "Requires 2FA at sign-in"
		},
		"status": {
			"label": "Status"
		},
		"password": {
			"label": "Password",
			"aside": "leave blank to generate"
		},
		"mustChange": {
			"label": "Must change password at first sign-in",
			"hint": "Recommended whenever someone else set the password."
		},
		"passwordPending": "A password change is pending at their next sign-in.",
		"passwordSetOrGenerate": "Set a new one, or generate a temporary one to hand over.",
		"resetPassword": "Reset password…",
		"errors": {
			"usernameTaken": "That username is already taken.",
			"emailTaken": "That email is already in use.",
			"invalidValue": "Invalid value"
		}
	},
	"resetPassword": {
		"title": "Reset password",
		"forUser": "For <strong>{{name}}</strong> <mono>({{username}})</mono>",
		"submit": "Reset password",
		"legend": "New password",
		"generateTitle": "Generate a temporary password",
		"generateDetail": "Phone-friendly, like Mango-Tiger-4821. Shown to you once.",
		"setTitle": "Set a specific password",
		"setDetail": "At least 8 characters.",
		"newPasswordAria": "New password",
		"warning": "Either way, <strong>{{name}}</strong> is signed out on every device and must choose a new password at next sign-in.",
		"confirm": {
			"label": "Your password",
			"hint": "Confirm it's you — not a misclick.",
			"wrong": "That isn't your password."
		},
		"invalidPassword": "Invalid password",
		"successSet": "Password set for {{name}}. They're signed out everywhere.",
		"error": "Couldn't reset password"
	},
	"reveal": {
		"titleCreated": "Account created",
		"titleReset": "Password reset",
		"forUser": "Temporary password for <strong>{{name}}</strong> <mono>({{username}})</mono>",
		"passwordAria": "Temporary password",
		"copied": "Copied",
		"toastCopied": "Password copied",
		"toastClipboard": "Couldn't access the clipboard — select the password and copy it by hand.",
		"noteOnce": "Shown <strong>once</strong> — it isn't stored anywhere. Pass it on now.",
		"noteReset": "Their existing sessions have been signed out, and they'll choose a new password at next sign-in.",
		"noteCreated": "They'll choose their own password at first sign-in."
	},
	"groupCard": {
		"title": "User group",
		"change": "Change",
		"assign": "Choose group",
		"inactive": "Inactive",
		"appliesAs": "Applies while this account acts as {{role}}.",
		"inactiveWarning": "This group is inactive, so it grants nothing until it is active again.",
		"roleMissingWarning": "This account no longer holds the {{role}} role, so the group does not apply.",
		"none": "<strong>No group yet.</strong> Acting as {{roles}}, this account sees <em>nothing</em> until it is in a group.",
		"saved": "{{name}} is in the new group.",
		"removed": "{{name}} is no longer in a group.",
		"saveFailed": "Couldn't change the group",
		"picker": {
			"titleAssign": "Choose a user group",
			"titleChange": "Change user group",
			"description": "The group decides where <strong>{{name}}</strong> may act and what they may do. One group per account.",
			"label": "Group",
			"placeholder": "Pick a group",
			"noGroups": "No groups for this account's roles",
			"inactiveOption": "Inactive — grants nothing",
			"onlyRole": "Only {{role}} groups are listed: this account holds that role.",
			"bothRoles": "Operation and Organization groups are listed: this account holds both roles.",
			"truncated_one": "Only the first {{count}} group, by name, is listed.",
			"truncated_other": "Only the first {{count}} groups, by name, are listed.",
			"noScopedRole": "This account holds none of Operation, Organization, Transport provider or Hotel, so no group can apply. Give it one of those roles first.",
			"applyNote": "Takes effect on the account's next request — no sign-out needed.",
			"remove": "Remove from group",
			"confirmRemove": "Remove {{name}} from the group? They will see nothing as Operation or Organization.",
			"save": "Save"
		}
	}
}
